import service from '@/services/integration/tray/TrayService'

export const trayModule = {
  namespaced: true,
  state: {
    integrationData: {
      BASE_URL: '',
      PASSWORD: '',
      USERNAME: null,
      NOME_EMPRESA: null,
      DE_PARA: '',
      ITEM_TAXAENTREGA: null,
      ITEM_GENERICO: null,
      FILIAL: null,
      COLUNAS_EXPORTACAO: null,
      CONVERTEPESOGRAMAS: null,
    },
    integrationsList: [],
    integrationsHeader: [
      { text: 'ID User', value: 'USERNAME' },
      { text: 'Nome Integração', value: 'NOME_EMPRESA' },
      { text: 'Selecionado', value: 'selected' },
      { text: 'Ações', value: 'actions' },
    ],
    integrateOrdersResponse: [],
    categoryList: [],
    productList: [],
    productColumnsList: [],
    manufacturerList: [],
    orderList: [],
  },
  mutations: {
    SET_INTEGRATE_ORDERS_RESPONSE(state, data) {
      state.integrateOrdersResponse = data.data
    },
    SET_ORDER_LIST(state, payload) {
      state.orderList = payload.data ?? payload
    },
    SET_CATEGORIES(state, payload) {
      state.categoryList = payload.data ?? payload
    },
    SET_PRODUCTS(state, payload) {
      state.productList = payload.data ?? payload
    },
    SET_PRODUCT_COLUMNS_AVAIABLE(state, payload) {
      state.productColumnsList = payload
    },
    SET_MANUFACTURERS(state, payload) {
      state.manufacturerList = payload.data ?? payload
    },
    SET_INTEGRATIONS(state, payload) {
      state.integrationList = payload.data
    },
  },
  actions: {
    async integrateOrders({ commit }, payload) {
      let response = await service.integrateOrders(payload)
      commit('SET_INTEGRATE_ORDERS_RESPONSE', response)
    },
    async getOrdersIntegration({ commit }, payload) {
      let response = await service.getOrders(payload)
      commit('SET_ORDER_LIST', response)
    },

    // PRODUTOS
    translateProductFromFirebird(context, payload) {
      return service.translateProductFromFirebird(payload)
    },
    translateProductToFirebird(context, payload) {
      return service.translateProductToFirebird(payload)
    },

    async getProductsIntegration({ commit }, payload) {
      let response = await service.getProductsIntegration(payload)
      commit('SET_PRODUCTS', response)
    },

    async getProductIntegration(context, payload) {
      return await service.getProductIntegration(payload)
    },

    async getProductColumnsAvaiable({ commit }) {
      let response = await service.getProductColumnsAvaiable()
      commit('SET_PRODUCT_COLUMNS_AVAIABLE', response)
    },

    // CATEGORIAS
    translateCategoryFromFirebird(context, payload) {
      return service.translateCategoryFromFirebird(payload)
    },
    translateCategoryToFirebird(context, payload) {
      return service.translateCategoryToFirebird(payload)
    },

    async getCategoriesIntegration({ commit }, payload) {
      let response = await service.getCategoriesIntegration(payload)
      commit('SET_CATEGORIES', response)
    },

    async getCategoryIntegration(context, payload) {
      let response = await service.getCategoryIntegration(payload)
      return response
    },

    async integrateCategories({ dispatch }, payload) {
      let response = await service.integrateCategories(payload)
      dispatch('getCategoriesIntegration')
      return response
    },

    // FABRICANTE
    translateManufacturerFromFirebird(context, payload) {
      return service.translateManufacturerFromFirebird(payload)
    },
    translateManufacturerToFirebird(context, payload) {
      return service.translateManufacturerToFirebird(payload)
    },

    async getManufacturersIntegration({ commit }, payload) {
      let response = await service.getManufacturersIntegration(payload)
      commit('SET_MANUFACTURERS', response)
    },

    async getManufacturerIntegration(context, payload) {
      return await service.getManufacturerIntegration(payload)
    },

    async integrateManufacturers({ dispatch }, payload) {
      let response = await service.integrateManufacturers(payload)
      dispatch('getManufacturersIntegration')
      return response
    },

    async getIntegrations({ commit }, payload) {
      let response = await service.getIntegrations(payload)
      commit('SET_INTEGRATIONS', response)
    },

    // WEBHOOKS SIMULATOR
    async removeProduct(context, payload) {
      return await service.removeProduct(payload)
    },
    async removeManufacturer(context, payload) {
      return await service.removeManufacturer(payload)
    },
    async removeCategory(context, payload) {
      return await service.removeCategory(payload)
    },
  },
  getters: {
    getOrders: (state) => {
      return state.orderList
    },
    getIntegration: (state) => {
      return state.integrationData
    },
    getIntegrateErrors: (state) => {
      return state.integrateOrdersResponse.error || []
    },
    getIntegrateInfos: (state) => {
      return state.integrateOrdersResponse.info || []
    },
    getCategories: (state) => {
      return state.categoryList
    },
    getManufacturers: (state) => {
      return state.manufacturerList
    },
    getProducts: (state) => {
      return state.productList
    },
    getProductColumnsAvaiable: (state) => {
      return state.productColumnsList
    },
    getIntegrations: (state) => {
      return state.integrationsList
    },
    getIntegrationsHeader: (state) => {
      return state.integrationsHeader || []
    },
    getManufacturerComboBox: (state) => {
      let comboBox = state.manufacturerList.map((manufacturer) => {
        return {
          ID: manufacturer.IDINTEGRACAO,
          NOME: manufacturer.FABRICANTE,
        }
      })
      return comboBox
    },
    getCategoryComboBox: (state) => {
      let comboBox = state.categoryList.map((category) => {
        return {
          ID: category.ID,
          NOME: category.NOME,
          IDINTEGRACAO: category.IDINTEGRACAO,
        }
      })
      return comboBox
    },
    getCategoryIntegratedComboBox: (state) => {
      let comboBox =
        state.categoryList.length > 0
          ? state.categoryList
              .filter((category) => category.IDINTEGRACAO != null)
              .map((category) => {
                return {
                  ID: category.ID,
                  NOME: category.NOME,
                }
              })
          : state.categoryList
      return comboBox
    },
  },
}
